import { styled } from '@mui/material/styles';

export const Image = styled('img')({});
